import React from 'react';

export function EditTask() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
        >
            <g clipPath="url(#clip0_2623_4698)">
                <path
                    d="M9.8808 2.68695L1.07743 11.491C1.0331 11.5354 1.0015 11.591 0.98594 11.6518L0.0101373 15.5683C-0.00420149 15.6265 -0.00331563 15.6873 0.0127094 15.745C0.0287344 15.8027 0.0593574 15.8552 0.101623 15.8976C0.166569 15.9623 0.254482 15.9987 0.346158 15.9988C0.37444 15.9988 0.402614 15.9953 0.430042 15.9884L4.34661 15.0125C4.4075 14.9972 4.46309 14.9656 4.50742 14.9211L13.3116 6.11769L9.8808 2.68695ZM15.4926 1.48653L14.5126 0.506596C13.8577 -0.148357 12.7161 -0.147707 12.0619 0.506596L10.8615 1.70702L14.2922 5.13763L15.4926 3.93724C15.8197 3.61022 15.9999 3.17491 15.9999 2.71196C15.9999 2.24901 15.8197 1.81371 15.4926 1.48653Z"
                    fill="#ADB0B5"
                />
            </g>
            <defs>
                <clipPath id="clip0_2623_4698">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
